/* ============================================================
   YorLook PDP — yorlook-pdp.js
   Handles: gallery, variant selection, qty, sticky bar,
            accordion, fit profile modal, wishlist, pincode
   No jQuery dependency — works alongside Shella.
   ============================================================ */

(function () {
  'use strict';

  /* ───────────────────────────────
     GALLERY
  ─────────────────────────────── */
  function initGallery() {
    var thumbs  = document.querySelectorAll('.yl-gallery__thumb');
    var slides  = document.querySelectorAll('.yl-gallery__slide');
    var main    = document.querySelector('.yl-gallery__main');
    var dots    = document.querySelectorAll('.yl-gallery__dot');
    var prevBtn = document.getElementById('ylGalleryPrev');
    var nextBtn = document.getElementById('ylGalleryNext');
    if (!thumbs.length || !slides.length) return;

    var current = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('active')) current = i; });

    function setActive(idx) {
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      current = idx;
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      slides.forEach(function (s) { s.classList.remove('active'); });
      dots.forEach(function (d) { d.classList.remove('active'); });
      if (thumbs[idx]) thumbs[idx].classList.add('active');
      if (slides[idx]) slides[idx].classList.add('active');
      if (dots[idx]) dots[idx].classList.add('active');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActive(parseInt(this.dataset.index, 10));
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        setActive(parseInt(this.dataset.index, 10));
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { setActive(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setActive(current + 1); });

    // Swipe / drag support on the main image
    if (main && slides.length > 1) {
      var startX = 0;
      var dx = 0;
      var isDragging = false;

      main.addEventListener('pointerdown', function (e) {
        isDragging = true;
        startX = e.clientX;
        dx = 0;
        main.classList.add('dragging');
      });

      main.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        dx = e.clientX - startX;
      });

      function endDrag() {
        if (!isDragging) return;
        isDragging = false;
        main.classList.remove('dragging');
        var threshold = 40;
        if (Math.abs(dx) > threshold) {
          setActive(current + (dx < 0 ? 1 : -1));
        }
        dx = 0;
      }

      main.addEventListener('pointerup', endDrag);
      main.addEventListener('pointercancel', endDrag);
      main.addEventListener('pointerleave', endDrag);
    }

    // Basic zoom — opens current image full-screen
    var zoomBtn = document.getElementById('ylZoom');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        var activeImg = document.querySelector('.yl-gallery__slide.active img');
        if (!activeImg) return;
        var overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;inset:0;z-index:500;background:rgba(0,0,0,.92);display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
        var img = document.createElement('img');
        img.src = activeImg.src;
        img.style.cssText = 'max-width:92vw;max-height:92vh;object-fit:contain;';
        overlay.appendChild(img);
        overlay.addEventListener('click', function () { document.body.removeChild(overlay); });
        document.body.appendChild(overlay);
      });
    }
  }

  /* ───────────────────────────────
     VIDEO CARDS ("See it in action")
     Play only while scrolled into view — keeps 3
     simultaneous videos from all decoding at once.
  ───────────────────────────────  */
  function initVideoCards() {
    var videos = document.querySelectorAll('.yl-video-card__media');
    if (!videos.length) return;

    var SLOW_RATE = 0.7;

    videos.forEach(function (v) {
      v.playbackRate = SLOW_RATE;
      v.defaultPlaybackRate = SLOW_RATE;
      v.addEventListener('loadedmetadata', function () { v.playbackRate = SLOW_RATE; });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target.closest('.yl-video-card');
        if (entry.isIntersecting) {
          if (card) card.classList.add('is-visible');
          entry.target.playbackRate = SLOW_RATE;
          entry.target.play().catch(function () {});
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.4 });

    videos.forEach(function (v) { observer.observe(v); });

    // Mobile carousel arrows — scroll by one card width per tap
    var track = document.getElementById('ylVideoGrid');
    var prev = document.getElementById('ylVideoPrev');
    var next = document.getElementById('ylVideoNext');
    if (track && prev && next) {
      var scrollByCard = function (dir) {
        var card = track.querySelector('.yl-video-card');
        if (!card) return;
        var gap = 14;
        var amount = card.getBoundingClientRect().width + gap;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      };
      prev.addEventListener('click', function () { scrollByCard(-1); });
      next.addEventListener('click', function () { scrollByCard(1); });
    }
  }

  /* ───────────────────────────────
     VARIANT SELECTION
     Works with Shopify's variant
     data baked into the page.
  ───────────────────────────────  */
  function initOptions() {
    var optionBtns = document.querySelectorAll('.yl-swatch, .yl-size');
    if (!optionBtns.length) return;

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var optionIdx = parseInt(this.closest('[data-option-index]').dataset.optionIndex, 10);
        // Deselect siblings
        var siblings = this.closest('[data-option-index]').querySelectorAll('button');
        siblings.forEach(function (s) { s.classList.remove('active'); });
        this.classList.add('active');
        updateVariant();
      });
    });

    function getSelectedOptions() {
      var groups = document.querySelectorAll('[data-option-index]');
      var selected = [];
      groups.forEach(function (group) {
        var active = group.querySelector('button.active');
        selected.push(active ? active.dataset.value : null);
      });
      return selected;
    }

    function updateVariant() {
      var chosen = getSelectedOptions();
      var variantsEl = document.getElementById('ylProductVariants');
      var variants = [];
      if (variantsEl) {
        try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) {}
      }

      var match = variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o != null; });
        return opts.length === chosen.length && opts.every(function (opt, i) { return opt === chosen[i]; });
      });

      var addBtn      = document.getElementById('ylAddBtn');
      var variantInput = document.getElementById('ylVariantId');
      var priceEl     = document.querySelector('.yl-price--current');
      var compareEl   = document.querySelector('.yl-price--compare');
      var saveEl      = document.querySelector('.yl-price--save');
      var stickyPrice = document.querySelector('.yl-sticky-add__price');

      if (match) {
        if (variantInput) variantInput.value = match.id;
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
        }
        var stickyBtn = document.getElementById('ylStickyBtn');
        if (stickyBtn) {
          stickyBtn.disabled = !match.available;
          stickyBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
        }
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (compareEl && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }
        if (saveEl && match.compare_at_price > match.price) {
          var saving = match.compare_at_price - match.price;
          saveEl.textContent = 'Save ' + formatMoney(saving);
          saveEl.style.display = '';
        } else if (saveEl) {
          saveEl.style.display = 'none';
        }
        if (stickyPrice) {
          var name = stickyPrice.querySelector('span');
          if (name) name.textContent = document.querySelector('.yl-pinfo__title') ? document.querySelector('.yl-pinfo__title').textContent.trim().substring(0, 28) : '';
          stickyPrice.lastChild.textContent = ' ' + formatMoney(match.price);
        }
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Select options'; }
        var stickyBtnNoMatch = document.getElementById('ylStickyBtn');
        if (stickyBtnNoMatch) { stickyBtnNoMatch.disabled = true; stickyBtnNoMatch.textContent = 'Select options'; }
      }
    }
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  }

  /* ───────────────────────────────
     QUANTITY
  ───────────────────────────────  */
  function initQty() {
    var down    = document.getElementById('ylQtyDown');
    var up      = document.getElementById('ylQtyUp');
    var display = document.getElementById('ylQtyDisplay');
    var input   = document.getElementById('ylQtyInput');
    var qty     = 1;

    function set(n) {
      qty = Math.max(1, n);
      if (display) display.textContent = qty;
      if (input)   input.value = qty;
    }

    if (down) down.addEventListener('click', function () { set(qty - 1); });
    if (up)   up.addEventListener('click',   function () { set(qty + 1); });
  }

  /* ───────────────────────────────
     STICKY ADD-TO-BAG (mobile)
  ───────────────────────────────  */
  function initSticky() {
    var bar     = document.getElementById('ylStickyAdd');
    var addBtn  = document.getElementById('ylAddBtn');
    if (!bar || !addBtn) return;

    var shown = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && !shown) {
          bar.classList.add('show');
          shown = true;
        } else if (entry.isIntersecting) {
          bar.classList.remove('show');
          shown = false;
        }
      });
    }, { threshold: 0 });
    observer.observe(addBtn);

    var stickyBtn = document.getElementById('ylStickyBtn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.getElementById('ylProductForm');
        if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  /* ───────────────────────────────
     ACCORDION
  ───────────────────────────────  */
  function initAccordion() {
    var items = document.querySelectorAll('[data-acc]');
    items.forEach(function (item) {
      var btn  = item.querySelector('.yl-acc-head');
      var body = item.querySelector('.yl-acc-body');
      if (!btn || !body) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        items.forEach(function (i) {
          i.classList.remove('open');
          var b = i.querySelector('.yl-acc-body');
          if (b) b.style.maxHeight = null;
          var h = i.querySelector('.yl-acc-head');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          body.style.maxHeight = body.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ───────────────────────────────
     SIZE CHART TOGGLE
  ───────────────────────────────  */
  function initSizeChart() {
    var toggle = document.getElementById('ylFitExpand');
    var chart  = document.getElementById('ylSizeChart');
    if (!toggle || !chart) return;
    toggle.addEventListener('click', function () {
      var open = chart.classList.toggle('open');
      toggle.textContent = open ? 'Hide size chart' : 'View size chart';
    });
    var link = document.getElementById('ylSizeGuideLink');
    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        chart.classList.add('open');
        toggle.textContent = 'Hide size chart';
        chart.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
  }

  /* ───────────────────────────────
     FIT PROFILE MODAL
  ───────────────────────────────  */
  function initFitProfile() {
    var setupLink  = document.getElementById('ylFitSetup');
    var modal      = document.getElementById('ylFitModal');
    var saveBtn    = document.getElementById('ylFitSave');
    var skipBtn    = document.getElementById('ylFitSkip');
    var fitContent = document.getElementById('ylFitContent');

    function openModal() { if (modal) modal.classList.add('open'); }
    function closeModal() { if (modal) modal.classList.remove('open'); }

    if (setupLink) setupLink.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
    if (skipBtn)   skipBtn.addEventListener('click', closeModal);
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }

    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var h = document.getElementById('fpHeight');
        var w = document.getElementById('fpWeight');
        var f = document.getElementById('fpFit');
        var b = document.getElementById('fpBody');
        if (!h.value || !w.value) {
          h.style.borderColor = h.value ? '' : 'red';
          w.style.borderColor = w.value ? '' : 'red';
          return;
        }
        var profile = { height: h.value, weight: w.value, fit: f.value, body: b.value };
        try { localStorage.setItem('yl_fit_profile', JSON.stringify(profile)); } catch (e) {}
        closeModal();
        renderFitResult(profile);
      });
    }

    try {
      var stored = localStorage.getItem('yl_fit_profile');
      if (stored) renderFitResult(JSON.parse(stored));
    } catch (e) {}

    function renderFitResult(profile) {
      if (!fitContent) return;
      var w = parseFloat(profile.weight) || 70;
      var rec = w < 60 ? 'S' : w < 72 ? 'M' : w < 85 ? 'L' : 'XL';
      var conf = w < 60 || w > 90 ? 78 : 92;
      fitContent.innerHTML =
        '<div class="yl-fit-result">' +
          '<b>' + rec + '</b>' +
          '<span class="conf">Recommended size · ' + conf + '% confidence</span>' +
        '</div>' +
        '<div class="yl-fit-meter"><i style="width:' + conf + '%"></i></div>' +
        '<p class="yl-fitblock__note">Based on your profile: ' + profile.height + ', ' + profile.weight + 'kg, ' + profile.body + ' build, ' + profile.fit + '.</p>' +
        '<a href="#" id="ylFitSetup" style="font-size:13px;font-weight:600;text-decoration:underline;">Update profile</a>';
      var newLink = document.getElementById('ylFitSetup');
      if (newLink) {
        newLink.addEventListener('click', function (e) {
          e.preventDefault();
          if (modal) modal.classList.add('open');
        });
      }
      var rec_lower = rec.toUpperCase();
      document.querySelectorAll('.yl-size').forEach(function (btn) {
        if (btn.dataset.value && btn.dataset.value.toUpperCase() === rec_lower) {
          btn.classList.add('rec');
        }
      });
    }
  }

  /* ───────────────────────────────
     WISHLIST (localStorage)
  ───────────────────────────────  */
  function initWishlist() {
    var btn = document.getElementById('ylWish');
    if (!btn) return;
    var productId = btn.dataset.product;
    var key = 'yl_wishlist';

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(key)) || []; }
      catch (e) { return []; }
    }
    function saveWishlist(arr) {
      try { localStorage.setItem(key, JSON.stringify(arr)); }
      catch (e) {}
    }

    var list = getWishlist();
    if (list.includes(productId)) btn.classList.add('active');

    btn.addEventListener('click', function () {
      var current = getWishlist();
      var idx = current.indexOf(productId);
      if (idx === -1) {
        current.push(productId);
        btn.classList.add('active');
      } else {
        current.splice(idx, 1);
        btn.classList.remove('active');
      }
      saveWishlist(current);
    });
  }

  /* ───────────────────────────────
     PINCODE DELIVERY CHECKER
  ───────────────────────────────  */
  function initPincode() {
    var input  = document.getElementById('ylPincodeInput');
    var btn    = document.getElementById('ylPincodeBtn');
    var result = document.getElementById('ylPincodeResult');
    if (!input || !btn || !result) return;

    btn.addEventListener('click', checkPincode);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') checkPincode();
    });
    input.addEventListener('input', function () {
      this.value = this.value.replace(/[^0-9]/g, '');
    });

    function checkPincode() {
      var pin = input.value.trim();
      if (!/^\d{6}$/.test(pin)) {
        result.innerHTML = '<span class="yl-pincode__error">Please enter a valid 6-digit pincode.</span>';
        return;
      }
      var today = new Date();
      var min = new Date(today);
      min.setDate(today.getDate() + 3);
      var max = new Date(today);
      max.setDate(today.getDate() + 5);
      var days   = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      function fmt(d) { return days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()]; }
      result.innerHTML =
        '<span class="yl-pincode__ok">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' +
          '<span>Delivery to <strong>' + pin + '</strong> expected by&nbsp;<strong>' + fmt(min) + ' – ' + fmt(max) + '</strong></span>' +
        '</span>';
    }
  }

  /* ───────────────────────────────
     INIT
  ───────────────────────────────  */
  function init() {
    initGallery();
    initVideoCards();
    initOptions();
    initQty();
    initSticky();
    initAccordion();
    initSizeChart();
    initFitProfile();
    initWishlist();
    initPincode();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
